
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 44,
  height: 44,
  viewBox: "0 0 120 120",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M67.787 24.002A39.963 39.963 0 0 1 96 52.213M65.656 37.412a23.978 23.978 0 0 1 16.928 16.927",
  stroke: "var(--theme-primary, #810ea9)",
  strokeWidth: 4.4,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M43.713 60.27a34.9 34.9 0 0 0 16.16 16.086 3.28 3.28 0 0 0 3.239-.245l10.358-6.907a3.31 3.31 0 0 1 3.14-.289l19.38 8.306a3.3 3.3 0 0 1 1.986 3.432C96.709 90.57 88.27 98 78.273 98 47.194 98 22 72.806 22 41.727c0-9.997 7.43-18.436 17.346-19.703a3.3 3.3 0 0 1 3.433 1.985l8.313 19.397a3.31 3.31 0 0 1-.273 3.117L43.936 57.04a3.28 3.28 0 0 0-.223 3.23Z",
  stroke: "#000",
  strokeWidth: 4.581,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"44\" height=\"44\" viewBox=\"0 0 120 120\" fill=\"none\">\r\n<path d=\"M67.7874 24.0015C81.5493 27.7026 92.2989 38.4523 96.0001 52.2142\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path d=\"M65.6565 37.4116C73.9137 39.6323 80.3635 46.0821 82.5842 54.3393\" stroke=\"var(--theme-primary, #810ea9)\" stroke-width=\"4.4\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M43.7131 60.2705C47.1467 67.2903 52.8369 72.9546 59.8722 76.3562C60.9194 76.8525 62.1508 76.7593 63.1115 76.1111L73.4705 69.2035C74.4012 68.5828 75.5825 68.4743 76.6108 68.915L95.9906 77.2206C97.343 77.7951 98.1525 79.1948 97.976 80.6535C96.7087 90.5698 88.2696 97.9995 78.2727 98C47.1941 98 22 72.8059 22 41.7273C22.0005 31.7304 29.4302 23.2913 39.3465 22.024C40.8052 21.8475 42.2049 22.657 42.7794 24.0094L51.0922 43.406C51.5289 44.425 51.4265 45.595 50.8194 46.5227L43.9358 57.0406C43.2985 58.0031 43.2139 59.2297 43.7131 60.2705Z\" stroke=\"#000000\" stroke-width=\"4.58082\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/phone.d426e17a77ad73fc4d7dc04a6b4a97c6.svg"),
        {
          React: SvgPhone,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      